const decryptEmail = (encodedString) => {
    // Holds the final output
    let email = '';
    // Extract the first 2 letters
    const keyInHex = encodedString.substr(0, 2);
    // Convert the hex-encoded key into decimal
    const key = parseInt(keyInHex, 16);
    // Loop through the remaining encoded characters in steps of 2
    for (let n = 2; n < encodedString.length; n += 2) {
        // Get the next pair of characters
        const charInHex = encodedString.substr(n, 2);
        // Convert hex to decimal
        const char = parseInt(charInHex, 16);
        // XOR the character with the key to get the original character
        // eslint-disable-next-line no-bitwise
        const output = char ^ key;
        // Append the decoded character to the output
        email += String.fromCharCode(output);
    }
    return email;
};

export default decryptEmail;
